import styled from 'styled-components'
import { DARK_VIOLET } from '@styles/colors'
import { GIVONIC } from '@styles/fonts'
import HomeBackground from '@assets/images/HomeBackground.png';
import { mapValue } from '@lib/utils';

// Background component (already existed in Home.tsx)
export const Background = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;
    padding-top: 24px;
    padding-left: 24px;
    padding-right: 24px;
    background-image: url(${HomeBackground});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center calc(50% - 100px);
`

// Container component
export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    overflow-y: auto;
    overflow-x: hidden;
    width: 100vw;
    height: 100vh;
    padding: 0;
    margin: 0;
    scrollbar-width: none;
    msOverflowStyle: none; // Hide scrollbar in IE and Edge
    -webkit-overflow-scrolling: touch; // Improve scrolling on iOS devices
`

// CollapsingHeaderContainer component - updated to use CSS variables
export const CollapsingHeaderContainer = styled.div`
    position: absolute;
    left: 0;
    right: 0;
    width: 100%;
    top: var(--header-top, -100px);
    opacity: var(--header-opacity, 0);
    transition: opacity 0.2s ease-out, top 0.2s ease-out;
    z-index: 10;
    will-change: opacity, top;
`

// BackgroundContainer component - updated to use CSS variables
export const BackgroundContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: 24px;
    padding-left: 12px;
    padding-right: 12px;
    gap: 16px;
    opacity: calc(1 - var(--header-opacity, 0));
    transition: opacity 0.2s ease-out, top 0.2s ease-out;
    will-change: opacity;
`

// RecentActivityContainer component - updated to use CSS variables
type RecentActivityContainerProps = {
    $collapsingHeaderHeight: number;
};

export const RecentActivityContainer = styled.div<RecentActivityContainerProps>`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: auto;
    z-index: 10;
    margin: 0;
    padding-top: 2vh;
    padding-bottom: 2vh;
    padding-left: 12px;
    padding-right: 12px;
    background-color: white;
    will-change: transform, position, top;
    transition: transform 0.1s ease-out, position 0.1s ease-out, top 0.1s ease-out;
    position: sticky;
    top: ${props => `${props.$collapsingHeaderHeight + 10}px`};
    transform: translateY(calc(var(--sticky-progress, 0) * -20px));
`

// RecentActivityText component
export const RecentActivityText = styled.span`
    font-family: ${GIVONIC.regular};
    color: ${DARK_VIOLET};
    font-size: 14px;
    text-transform: uppercase;
    background-color: white;
    z-index: 9;
`

// ActivityListContainer component
export const ActivityListContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-left: 12px;
    padding-right: 12px;
`

// Spacer component
export const Spacer = styled.div`
    width: 100%;
    min-height: 20vh; // Force content to be taller than viewport
`

const windowHeight = window.innerHeight;

// ChatBubbleContainer component
export const ChatBubbleContainer = styled.div`
    right: 0;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    padding-right: 10vw;
    bottom: ${mapValue(windowHeight, 0, windowHeight, 0, 100)}px;
    position: fixed;
    z-index: 10;
`

export const AlertBoxContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 0 12px;
`